'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

ScenarioConfig=function(){_createClass(ScenarioConfig,null,[{key:'$inject',get:function()
{return['$stateProvider','$urlMatcherFactoryProvider']}}]);

function ScenarioConfig($stateProvider,$urlMatcherFactoryProvider){_classCallCheck(this,ScenarioConfig);
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('scenario',{
views:{
"breadcrumbs@":{
templateUrl:`/templates/layout/breadcrumbs`}},


params:{
personInfo:null,
originalInputs:null,
schedule:null,
route:null,
fatigueThreshold:null,
queryInterval:null}});


$stateProvider.state(feature.fullName,feature.config);
}return ScenarioConfig}();


module.exports=ScenarioConfig;
//# sourceMappingURL=scenarioConfig.js.map
